$.fn.expandCollapse = function () {
  let $expandCollapseContainers = $(this);
  let numExpanded = 0;
  let $toggleAllContainer;
  let $toggleAllLink;

  function _getToggleAllLabel() {
    return numExpanded ? "Collapse all" : "Expand all";
  }

  /**
   * Iterate around the containersw and identify which are currently expanded
   * Note we can't use the num expanded global variable on delta 2.0 style filters without breaking old pages thus we use this
   * @returns {number}
   * @private
   */
  function _calculateNumExpanded(){
    let tempNumExpanded = 0;

    $expandCollapseContainers.each(function () {
      let $currentContainer = $(this);

      if ($currentContainer.hasClass("js-expander-expanded")) {
        tempNumExpanded++;
      }
    })

    return tempNumExpanded;
  }

  function _setGDSToggleAll() {
    if ($(".js-expander-toggle-all-gds").length) {
      // Select the elements into variables
      let $showAll = $('.govuk-accordion__section-toggle-show-all-gds');
      let $hideAll = $('.govuk-accordion__section-toggle-hide-all-gds');
      let $toggleAllContainer = $showAll.parent();
      let gdsNumExpanded = _calculateNumExpanded();

      if (gdsNumExpanded > 0) {
        $showAll.hide();
        $hideAll.show();

        $toggleAllContainer.off('click');
        $toggleAllContainer.on("click", function (event) {
          event.preventDefault();
          $expandCollapseContainers.trigger("slide:collapse-all");
          _setGDSToggleAll();
        })
      } else {
        $showAll.show();
        $hideAll.hide();

        $toggleAllContainer.off('click');
        $toggleAllContainer.on("click", function (event) {
          event.preventDefault();
          $expandCollapseContainers.trigger("slide:expand-all");
          _setGDSToggleAll();
        })
      }
    }
  }

  return $expandCollapseContainers.each(function () {
    var $container = $(this);

    function _syncAria(isExpanded) {
      var $handle = $container.find(".js-expander-handle:first");
      var $target = $container.find(".js-expander-target");

      if ($handle.length) {
        $handle.attr("aria-expanded", isExpanded ? "true" : "false");
      }
      if ($target.length) {
        $target.attr("aria-hidden", isExpanded ? "false" : "true");
      }
    }

    function _slideToggle(toState) {
      var $target = $container.find(".js-expander-target");
      if (toState && toState === "collapse") {
        if ($target.length && $container.hasClass("js-expander-expanded")) {
          numExpanded -= 1;
        }

        $container.removeClass("js-expander-expanded");
        _syncAria(false);
        $target.slideUp();
      } else if (toState && toState === "expand") {
        if ($target.length && !$container.hasClass("js-expander-expanded")) {
          numExpanded += 1;
        }

        $container.addClass("js-expander-expanded");
        _syncAria(true);
        $target.slideDown();
      }

      _setGDSToggleAll();

      if ($toggleAllLink) {
        $toggleAllLink.text(_getToggleAllLabel());
      }
    }

    if ($container.hasClass("js-expander-initial-expand")) {
      $container.addClass("js-expander-expanded");
    }

    _syncAria($container.hasClass("js-expander-expanded"));

    $container
        .on("slide:collapse-all", function () {
          _slideToggle("collapse");
        })
        .on("slide:expand-all", function () {
          _slideToggle("expand");
        })
        .find(".js-expander-handle:first")
        .wrapInner('<a href="#" />')
        .on("click", function (event) {
          event.preventDefault();
          var action = $container.hasClass("js-expander-expanded")
              ? "collapse"
              : "expand";
          _slideToggle(action);
        });

    if ($container.hasClass("js-expander-toggle-all")) {
      $toggleAllLink = $(
          '<a href="#" class="js-expander-collapse-all">' +
          _getToggleAllLabel() +
          "</a>",
      );
      $toggleAllContainer = $("<li />").append($toggleAllLink);

      $container
          .find(".js-control-container .action-right")
          .before($toggleAllContainer);

      $toggleAllLink.on("click", function (event) {
        event.preventDefault();
        if (numExpanded) {
          $expandCollapseContainers.trigger("slide:collapse-all");
        } else {
          $expandCollapseContainers.trigger("slide:expand-all");
        }

        $(this).text(_getToggleAllLabel());
      });
    }

    _setGDSToggleAll();

    return this;
  });
};
